export default "__VITE_ASSET__C9e2oyb8__"